function envBoolean (value, defaultValue = false) {
  if (value === undefined || value === '') {
    return defaultValue
  }

  return value === true || value === 'true' || value === '1'
}

export default {
  lastUpdate: process.env.APP_LAST_UPDATE || '',
  apiUrl: process.env.APP_API_URL || '',
  uiUrl: process.env.APP_UI_URL || '',
  keyPublic: process.env.APP_KEY_PUBLIC || '',
  cloudfireSiteKey: process.env.APP_CLOUDFIRE_SITE_KEY || '',
  cloudfireSecretKey: process.env.APP_CLOUDFIRE_SECRET_KEY || '',
  cloudfireEnabled: envBoolean(process.env.APP_CLOUDFIRE_ENABLED),
  titleWeb: process.env.APP_TITLE_WEB || '',
  descriptionWeb: process.env.APP_DESCRIPTION_WEB || ''
}



// WEBPACK FOOTER //
// ./src/config/env.js